import { inject, Service, service } from './di'
import { EventService } from './EventService'
import { AD_BLOCKER_POPUP_TAG_ELEMENT_ID } from '../components/flipp-info-popup/InfoPopup'

/*
 * This service relies on presence of script 'static/wpadgu-clicks.js'
 * (the solution for detection of ad blockers was taken from https://www.detectadblock.com)
 *
 * */

const AD_BLOCKER_POPUP_SHOWN_FLAG_NAME = 'adBlockerDetectedPopupShown'

@service('adBlockerDetectionService')
export class AdBlockerDetectionService extends Service {
    @inject eventService: EventService
    init() {
        if (this.isDetected()) {
            const wasDisplayed = sessionStorage.getItem(
                AD_BLOCKER_POPUP_SHOWN_FLAG_NAME
            )
            if (!wasDisplayed) {
                this.eventService.displayInfoPopup(
                    AD_BLOCKER_POPUP_TAG_ELEMENT_ID
                )

                sessionStorage.setItem(AD_BLOCKER_POPUP_SHOWN_FLAG_NAME, 'true')
            }
        } else {
            sessionStorage.removeItem(AD_BLOCKER_POPUP_SHOWN_FLAG_NAME)
        }
    }

    isDetected() {
        return !document.getElementById('MqVSiuhWaJCT')
    }
}
